module.exports = __webpack_public_path__ + "img/02.e59cb1dc.jpg";